<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-dark navbar-info">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#"
          ><i class="fas fa-bars"></i
        ></a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <div class="noti  align-items-center d-flex">
        <li class="nav-item dropdown">
          <a
            class="user-panel mt-0 pb-0 mb-0 d-flex"
            data-toggle="dropdown"
            href="javascript:void(0)"
          >
            <div
              v-if="notiData && notiData.length > 0"
              class="noti-dot text-red badge badge-pill badge-danger"
            >
              .
            </div>
            <div class="text-white">
              <i class="fas fa-bell"></i>
            </div>
          </a>

          <div
            v-if="notiData && notiData.length > 0"
            class="dropdown-menu dropdown-menu-lg dropdown-menu-right mt-4 noti-items"
          >
            <span
              class="dropdown-item dropdown-header text-white"
              style="background-color: #17a2b8; font-size: 15px;"
              >แจ้งเตือน</span
            >
            <div
              v-for="(item, index) in notiData"
              :key="index"
            >
              <div class="dropdown-divider"></div>
              <a
                href="javascript:void(0)"
                class="dropdown-item"
                @click="linkReceived(item.url,item.branchName)"
              >
                <div class="title">{{ item.title }}</div>
                <div class="text-date">{{ item.date }}</div>
              </a>
            </div>
          </div>
        </li>
      </div>
      <!-- Notifications Dropdown Menu -->

      <li class="nav-item dropdown">
        <!-- Sidebar user panel (optional) -->
        <a
          class="user-panel mt-0 pb-0 mb-0 d-flex"
          data-toggle="dropdown"
          href="javascript:void(0)"
        >
          <div class="image">
            <img
              src="../../static/dist/img/avatar04.png"
              class="img-circle elevation-2"
              alt="User Image"
            />
          </div>
          <div class="info">
            <b class="d-block text-white">{{ $store.state.user.username }}</b>
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right mt-4">
          <span class="dropdown-item dropdown-header"
            >ตำแหน่ง: {{ $store.state.user.role_name }}</span
          >
          <div class="dropdown-divider"></div>
          <a
            href="javascript:void(0)"
            class="dropdown-item"
            @click="$router.push('/profile')"
          >
            <i class="fas fa-user-circle mr-3"></i> ข้อมูลส่วนตัว
          </a>
          <div class="dropdown-divider"></div>
          <a href="javascript:void(0)" class="dropdown-item" @click="logout">
            <i class="fas fa-sign-out-alt mr-3"></i> ออกจากระบบ
          </a>
        </div>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import apiCenter from "../services/service_undefined";

export default {
  data () {
    return {
      notiData: []
    };
  },
  created () {
    // get data from here
    this.getRemainStock();
  },
  methods: {
    logout () {
      this.$store.state.isLoading = true;
      this.$store.commit("clearState");
      window.location = "/login";
    },
    getRemainStock (){
      apiCenter.getRemainStock(
        {
          branchName: ""
        },
        results => {
          if (results.data.result.length > 0) {
            this.notiData =results.data.result;
          }
        },
        errors => {
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
        }
      );
    },
    linkReceived (item,branchName) {
      this.$store.state.branchName = branchName;
      this.$router.push(item)
    }
  }
};
</script>
<style scoped>
.noti .fa-bell {
  font-size: 22px;
}
.noti .dropdown-header {
  text-align: left !important;
}
.noti .dropdown-header:hover {
  background-color: #17a2b8;
}
.title {
  font-size: 13px;
}
.text-date {
  color: #cbd1d7;
  font-size: 10px;
}
.noti-dot {
  font-size: 5px;
  position: absolute;
  right: 0px;
}
.noti-items {
  max-height: 20rem;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue